/*
 * NOTE if ColorSchemeClass values change, make sure to update:
 * - DB values
 * - Scss classes
 */

export enum ColorSchemeClass {
  Schema1 = 'Default',
  Schema2 = 'MediumVioletRed',
  Schema3 = 'CBREGreen',
  Schema4 = 'RoyalBlue',
  Schema5 = 'SlateGray',
}

export enum ColorItemSchemeClass {
  Expire12 = 'expire-12',
  Expire24 = 'expire-24',
  Expire36 = 'expire-36',
  Expire48 = 'expire-48',
  ExpireLong = 'expire-long',
  ExpireNA = 'expire-na',
  ExpireUnaccounted = 'expire-un',
}
